import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const rootStyle = css`
  border: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;

export const labelStyle = css`
  align-items: center;
  cursor: pointer;
  display: inline-flex;

  ${MEDIA_QUERY_FOR_PC} {
    column-gap: 12px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    column-gap: 9px;
  }
`;
